import * as paypalCoordinators from './paypal'

export default Object.freeze({
  ...paypalCoordinators,
})
